/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ProductPositionInstallationReferenceFragment = {
  __typename: "ProductPositionInstallationReference"
  id: string
  title?: string | null
  permalink: string
  position: number
}

export const ProductPositionInstallationReferenceFragmentDoc = gql`
  fragment ProductPositionInstallationReference on ProductPositionInstallationReference {
    id
    title
    permalink
    position
  }
`
